import SidebarWidgetError from './SidebarWidgetError'

export default SidebarWidgetError
